<template>
  <div class="t-28 fw-7 onyx">Watchlist Overlap</div>
  <div class="t-16 m-tx4">
    Enter up to three Letterboxd usernames to see what films are in everyone's watchlists*.
  </div>
  <div class="t-12 dark-gray m-tx1">*Only the first ~1000 films per watchlist</div>
  <div class="m-tx4">
    <div v-if="isScraping" class="f">
      <div class="t-12">Fetching watchlists, this may take a minute...</div>
      <BaseLoading class="w-x18" />
    </div>
    <WatchlistsOverlap
      v-else-if="results"
      :films="filmListWithCounts"
      :usernames="Object.keys(results)"
    />
    <WatchlistsScrape @scrape="scrape" v-else />
  </div>
</template>

<script setup>
  import { ref, computed, onMounted } from 'vue';
  import axios from 'axios';

  import { useToastStore } from '../../stores/toast_store.js';
  const { setToast } = useToastStore();

  const isScraping = ref(false);
  const results = ref(null);

  const scrape = (usernames) => {
    isScraping.value = true;
    const useCache = true;
    const limit = 1000;
    axios.get(`/apps/watchlists/scrape?usernames=${usernames.join(',')}&use_cache=${useCache}&limit=${limit}`)
      .then(({ data }) => {
        isScraping.value = false;
        setToast({ text: 'Successfully fetched data!', type: 'success' });
        results.value = data.results;
      })
      .catch(() => {
        setToast({ text: 'Sorry, there was an error. Try again!', type: 'failure' });
        isScraping.value = false;
      });
  };

  const filmListWithCounts = computed(() => {
    if (results.value) {
      const films = {};
      Object.keys(results.value).forEach((username) => {
        const filmsForUser = results.value[username];
        filmsForUser.forEach((film) => {
          if (films[film.id]) {
            films[film.id].users.push(username);
          } else {
            films[film.id] = { ...film, users: [username] };
          }
        });
      });
      return Object.values(films);
    }
  });

  // Lifecycle Hooks
  onMounted(() => {
    // Dev only below, add usernames to the list to scrape on page load
    // const defaultUsers = [];
    // scrape(defaultUsers);
  });
</script>